import {InjectionToken} from '@angular/core';

export interface PicmonicConfig {
    EntrypointUrl: string;
}

export const PICMONIC_CONFIG = new InjectionToken<PicmonicConfig>('PICMONIC_CONFIG');
